// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2601":"8c5a47ce","5197":"965ff8e9","6394":"9da68769"}[chunkId] + ".chunk.css";
};